<template lang="pug">
  #ProgramAdminDetails
    //- FIRST NAME
    BField(
      :type="{'is-danger': errors.has(firstName.fieldName)}"
      :message="errors.first(firstName.fieldName)"
      :addons="false"
    )
      WtLabel(
        slot="label"
        :text="'First Name'"
        :label-for="firstName.fieldName"
        required
      )
      BInput(
        :name="firstName.fieldName"
        :id="firstName.fieldName"
        v-validate="{ required: true, regex: /^[a-z ,.'-]+$/i }"
        placeholder="First Name"
        v-model="firstName.value"
      )

    //- LAST NAME
    BField(
      :type="{'is-danger': errors.has(lastName.fieldName)}"
      :message="errors.first(lastName.fieldName)"
      :addons="false"
    )
      WtLabel(
        slot="label"
        :text="'Last Name'"
        :label-for="lastName.fieldName"
        required
      )
      BInput(
        :name="lastName.fieldName"
        :id="lastName.fieldName"
        v-validate="{ required: true, regex: /^[a-z ,.'-]+$/i }"
        placeholder="Last Name"
        v-model="lastName.value"
      )

    //- USERNAME
    BField(
      :type="{'is-danger': errors.has(username.fieldName)}"
      :message="errors.first(username.fieldName)"
    )
      UniquenessCheck(
        label="User Name"
        :name="username.fieldName"
        entity="memberUsername"
        placeholder="username01"
        v-model="username.value"
        @validName="onValidUsername"
        v-validate="'required'"
        :required="true"
      )

    //- EMAIL
    BField(
      :type="{'is-danger': errors.has(email.fieldName)}"
      :message="errors.first(email.fieldName)"
    )
      UniquenessCheck(
        label="Email Address"
        :name="email.fieldName"
        entity="memberEmail"
        placeholder="name@email.com"
        v-model="email.value"
        @validName="onValidEmail"
        v-validate="'required'"
        :required="true"
      )
    //- PASSWORD
    BField(
      :type="{'is-danger': errors.has(password.fieldName)}"
      :message="errors.first(password.fieldName)"
      :addons="false"
    )
      WtLabel(
        slot="label"
        :text="'Password'"
        :label-for="password.fieldName"
        required
      )
      BInput(
        ref="password"
        :name="password.fieldName"
        :id="password.fieldName"
        type="password"
        v-validate="'required'"
        placeholder="*********"
        v-model="password.value"
        password-reveal
      )
      PasswordComplexityCheck(:password="password.value")
      BField(
        label="Confirm Password"
        :label-for="passwordConfirm.fieldName"
        :type="{'is-danger': errors.has(passwordConfirm.fieldName)}"
        :message="errors.first(passwordConfirm.fieldName)"
      )
        BInput(
          :name="passwordConfirm.fieldName"
          :id="passwordConfirm.fieldName"
          type="password"
          v-validate="'required|confirmed:password'"
          data-vv-as="password"
          placeholder="*********"
          v-model="passwordConfirm.value"
          password-reveal
        )

</template>

<script>
import WtButton from "@@/WtButton/WtButton";
import WtLabel from "@@/WtLabel/WtLabel";
import WtTitle from "@@/WtTitle/WtTitle";
import PasswordComplexityCheck from "@@/PasswordComplexityCheck.vue";
import UniquenessCheck from "@@/WtUniquenessCheckInput/WtUniquenessCheckInput";

export default {
  name: "ProgramAdminDetails",

  components: {
    PasswordComplexityCheck,
    UniquenessCheck,
    WtButton,
    WtLabel,
    WtTitle
  },

  data() {
    return {
      firstName: { fieldName: "first-name", value: "" },
      lastName: { fieldName: "last-name", value: "" },
      username: { fieldName: "username", value: "" },
      email: { fieldName: "email", value: "" },
      password: { fieldName: "password", value: "" },
      passwordConfirm: { fieldName: "password-confirm", value: "" },
      registeredMemberId: null,
      isUsernameValid: false,
      isEmailValid: false
    };
  },

  computed: {
    formData() {
      return {
        firstName: this.firstName.value,
        lastName: this.lastName.value,
        username: this.username.value,
        email: this.email.value,
        password: this.password.value,
        passwordConfirm: this.passwordConfirm.value
      };
    },

    isPasswordFilled() {
      return (
        !this._.isEmpty(this.password.value) &&
        !this._.isEmpty(this.passwordConfirm.value) &&
        this.password.value === this.passwordConfirm.value
      );
    },

    isAllValid() {
      return (
        !this.errors.any() &&
        this.isUsernameValid &&
        this.isEmailValid &&
        this.isPasswordFilled
      );
    }
  },

  watch: {
    isAllValid() {
      this.$emit("newProgramAdminDetails", {
        isValid: this.isAllValid,
        formData: this.formData
      });
    }
  },

  methods: {
    onValidUsername(event) {
      return (this.isUsernameValid = event);
    },

    onValidEmail(event) {
      return (this.isEmailValid = event);
    }
  }
};
</script>

<style lang="sass" scoped>
#ProgramAdminDetails
</style>
